var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M230.247 163.003C231.188 164.18 231.778 165.598 231.948 167.096C232.119 168.593 231.863 170.108 231.21 171.466C230.557 172.824 229.534 173.97 228.259 174.772C226.983 175.574 225.507 176 224 176H48V216C48 218.122 47.1571 220.157 45.6569 221.657C44.1566 223.157 42.1217 224 40 224C37.8783 224 35.8434 223.157 34.3431 221.657C32.8429 220.157 32 218.122 32 216V48C32 45.8783 32.8429 43.8434 34.3431 42.3431C35.8434 40.8429 37.8783 40 40 40H224C225.507 40.0001 226.983 40.4257 228.259 41.2279C229.534 42.0301 230.557 43.1762 231.21 44.5343C231.863 45.8925 232.119 47.4073 231.948 48.9045C231.778 50.4017 231.188 51.8203 230.247 52.997L186.245 108L230.247 163.003Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanner);
export default __webpack_public_path__ + "static/media/banner.55c49b6067399d1d0c9f9ff28d37806d.svg";
export { ForwardRef as ReactComponent };